# frozen_string_literal: true

module JaroWinkler
  VERSION = '1.5.4'
end
